import type { JSX } from 'react';
import './RolePlate.css';

interface RolePlateProps {
  /** Italic-small-caps preamble line, e.g. "You have been assigned the role".
   *  Required (no English default) so the copy always comes through i18n;
   *  callers pass t('meeting.rolePlate.preamble'). */
  preamble: string;
  /** Role display name in source case; rendered uppercase via CSS. */
  roleName: string;
}

/**
 * Role plate: the recto identity block on phases that reveal a role to the
 * player (currently GhostMeeting; future RoleReveal will reuse the type
 * treatment). Pure type, no mounted card — the chapbook "your hand" register.
 *
 * The role name is set with `white-space: nowrap` so 8-letter "VILLAGER" never
 * mid-word breaks at clamp(2.5rem, 4vw, 3.5rem). Capped below the Wordmark's
 * 5rem max so this reads as a sub-frame, not the page's primary title.
 */
export function RolePlate({
  preamble,
  roleName,
}: RolePlateProps): JSX.Element {
  return (
    <header className="susdle-role-plate">
      <p className="susdle-role-plate__preamble">{preamble}</p>
      <p className="susdle-role-plate__role">{roleName}</p>
    </header>
  );
}
